import lodash from "lodash";
import Vuetify from "vuetify";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DATA_TYPES,
  FORM_ACTION_CONSTANTS,
  INFORMATION_INIT
} from "../../constants/FormActionModal.constants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { Field } from "@/modules/FormTemplate/models/Field";
import { KeyValue } from "@/shared/models/KeyValue";
import { PreventKey } from "@/shared/mixins/mixins";
import { UNDEFINED } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";

Vue.use(Vuetify);
@Component({ name: "InformationElement", components: { DynamicSelect } })
export default class InformationElement extends PreventKey {
  @Prop({ default: 0 }) index!: number;
  @Prop() formTemplates!: FormStatus[];
  @Prop() formInformation!: FormInformation;

  primaryRoundBtnClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredFieldObject = [FORM_VALIDATORS.REQUIRED_OBJECT];
  requiredFieldTxt = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredNumberTxt = [FORM_VALIDATORS.NUMBER_FIELD];

  SELECT_TEMPLATE = FORM_ACTION_CONSTANTS.LABELS.SELECT_INFO_TEMPLATE;
  INFO_NAME = FORM_ACTION_CONSTANTS.LABELS.INFO_NAME;
  DELETE_INFORMATION = FORM_ACTION_CONSTANTS.LABELS.DELETE_INFORMATION;
  OPERATION = FORM_ACTION_CONSTANTS.LABELS.OPERATION;
  FROM = FORM_ACTION_CONSTANTS.LABELS.FROM;
  STEP = FORM_ACTION_CONSTANTS.LABELS.STEP;
  GET_FIELD = FORM_ACTION_CONSTANTS.LABELS.GET_FIELD;
  NO_FIELDS = FORM_ACTION_CONSTANTS.LABELS.NO_FIELDS;
  NO_NUMERIC_FIELDS = FORM_ACTION_CONSTANTS.LABELS.NO_NUMERIC_FIELDS;

  COUNT = FORM_ACTION_CONSTANTS.INFO_OPERATION.COUNT;
  GET = FORM_ACTION_CONSTANTS.INFO_OPERATION.GET;
  GET_MULTIPLE = FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE;
  INFO_OPERATIONS = [
    FORM_ACTION_CONSTANTS.INFO_OPERATION.COUNT,
    FORM_ACTION_CONSTANTS.INFO_OPERATION.GET,
    FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE
  ];
  STEP_DATA = [
    FORM_ACTION_CONSTANTS.STEP.YEAR,
    FORM_ACTION_CONSTANTS.STEP.MONTH,
    FORM_ACTION_CONSTANTS.STEP.DAY
  ];

  selectedFormTemplate: FormStatus = {} as FormStatus;
  localFormInformation: FormInformation = lodash.cloneDeep(INFORMATION_INIT);
  formKey = 1;

  formTemplateModel = [{ id: "", name: "" }];
  formSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SELECT_TEMPLATE,
    hideDetails: true
  };

  get selectedFormKey() {
    return this.formTemplateModel[0].id;
  }

  set selectedFormKey(value: string) {
    const option = this.formSelectConfig.listAll.find(
      item => item.id === value
    );
    this.formTemplateModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  created() {
    this.updateFormInformation();
  }

  @Watch("formInformation")
  updateFormInformation() {
    this.updateDataDynamicSelect();
    this.selectedFormKey = (this.formInformation
      .formTemplate as FormStatus)._key;
    this.localFormInformation = this.formInformation;
  }

  editedElement() {
    this.localFormInformation.formTemplate = this.formTemplates.find(
      e => e._key == this.selectedFormKey
    ) as FormStatus;
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.INFORMATION.EDIT_ELEMENT,
      this.localFormInformation,
      this.index
    );
    this.formKey = 1 - this.formKey;
  }

  deleteInformation() {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.INFORMATION.DELETE_ELEMENT,
      this.index
    );
  }

  @Watch("formTemplateModel")
  changedTemplate(oldVal?: { id: string; name: string }[]) {
    if (!oldVal || (oldVal && oldVal[0].id == "")) {
      this.formInformation.field = "";
      this.formInformation.operation = "";
      delete this.formInformation.step;
      delete this.formInformation.time;
      delete this.formInformation.value;
    }
    this.editedElement();
  }

  getSelectedFields() {
    let tempFields: Field[];
    switch ((this.formInformation.operation as KeyValue).key) {
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.COUNT.key:
        return [];
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.GET.key:
        tempFields = (this.formInformation.formTemplate as FormStatus).fields;
        return tempFields;
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE.key:
        tempFields = (this.formInformation
          .formTemplate as FormStatus).fields.filter(
          field => field.schema.type === DATA_TYPES.NUMBER
        );
        return tempFields ?? [];
    }
  }

  changedOperation() {
    if (typeof this.formInformation.operation === UNDEFINED) {
      this.formInformation.operation = "";
    }
    switch ((this.formInformation.operation as KeyValue).key) {
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.COUNT.key:
        this.formInformation.dataType = DATA_TYPES.NUMBER;
        break;
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.GET.key:
        this.formInformation.dataType = DATA_TYPES.STRING;
        break;
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE.key:
        this.formInformation.dataType = DATA_TYPES.ARRAY;
        break;
    }
    this.formInformation.field = "";
    delete this.formInformation.step;
    delete this.formInformation.time;
    this.editedElement();
  }

  fieldSelected(field: Field) {
    switch ((this.formInformation.operation as KeyValue).key) {
      case FORM_ACTION_CONSTANTS.INFO_OPERATION.GET.key:
        this.formInformation.dataType =
          field && field.type != DATA_TYPES.FORMULA
            ? field.schema.type
            : field && field.type == DATA_TYPES.FORMULA
            ? field.type
            : "";
        break;
      default:
        this.formInformation.dataType = DATA_TYPES.STRING;
    }
    this.editedElement();
  }

  getFormTemplates(name?: string) {
    this.$emit(FORM_ACTION_CONSTANTS.EVENTS.GET_FORM_TEMPLATES, name);
  }

  @Watch("formTemplates")
  updateDataDynamicSelect() {
    this.formSelectConfig.listAll = this.formTemplates.map(item => {
      return { id: item._key, name: item.name };
    });
  }
}
